module.exports = __webpack_public_path__ + "static/img/role.ba47de7.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/wxsjglm/role.png
// module id = JMNj
// module chunks = 7